import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class GroupService extends Token {
  
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "grupos",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    }).then((res) => res.data);
  }

  create(group) {
    return axios({
      method: "post",
      url: this.api_url + "grupos",
      withCredentials: true,
      data: group,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    });
  }
  update(group) {
    return axios({
      method: 'put',
      url: this.api_url + 'grupos/' + group.id,
      withCredentials: true,
      data: group,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'grupos/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
}
